import styled from 'styled-components';
import ErrorIcon from '../../icons/error-filled.svg';
import PorscheCloseIcon from '../../icons/porscheCloseIcon.svg';
import DefaultErrorMessageBox, { type ErrorMessageBoxProps } from '../default/ErrorMessageBox';

const ErrorText = styled(DefaultErrorMessageBox)`
    border: 0;
`;

const ErrorMessageBox = (props: Omit<ErrorMessageBoxProps, 'icon' | 'closeIcon'>) => (
    <ErrorText className="porche-error" closeIcon={PorscheCloseIcon} icon={ErrorIcon} {...props} />
);

export default ErrorMessageBox;
